import { Commodities } from "~/features/commodities/index.tsx";
import { Construction } from "~/shared/components/construction/construction.tsx";
import { LoadingSpinner } from "~/shared/components/loading-spinner/loading-spinner.tsx";
import { useFeatureFlagGate } from "~/shared/hooks/use-feature-flag-gate.ts";

export const CommoditiesPage = () => {
	const { isReady, isEnabled } = useFeatureFlagGate("traxLtlCommodityList");

	if (!isReady) {
		return <LoadingSpinner />;
	}

	return isEnabled ? <Commodities /> : <Construction />;
};
